module.exports = __webpack_public_path__ + "img/nfl.d4c96f80.png";